import { Theme } from "@mui/material";
import { borderRadius, fontFamily, fontStyle, SxProps } from "@mui/system";
import { CSSProperties } from 'react';
import { desktopPadding } from "@/taskpane/styles/responsive";

import type { PaletteColor } from "./FoldersList.types";
import { PiX } from "react-icons/pi";

export default {
    pageContainer: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100%", // Take full height of parent
        "@media (min-width: 550px)": {
            maxWidth: "800px",
            margin: "0 auto",
        }
    },

    searchContainer: {
        padding: "3px",
        flexShrink: 0, // Prevent search section from shrinking
        pt: 1, // Add vertical padding
        pb: 0.5, // Add vertical padding
        ...desktopPadding, // Add padding left and right around the search bar
    },

    searchField: {
        bgcolor: "white",
        "& .MuiInputBase-root": {
            padding: "0!important",
            "& ::placeholder": { 
                fontSize: "12px!important" 
            }
        }
    },

    listContainer: {
        px: "5px",
        flex: 1, // Take remaining space
        minHeight: 0, // Allow container to shrink
        overflow: "hidden", // Hide overflow
    },

    buttonsGrid: {
        padding: "3px",
        flexShrink: 0, // Prevent buttons section from shrinking
        pt: 1, // Add vertical padding
        ...desktopPadding, // Add padding left and right around the grid of buttons
    },

    buttonsContainer: {
        "@media (min-width: 620px)": {
            justifyContent: "center",
            gap: "5%",
            padding: "4px",
            "& .MuiGrid-item": {
                paddingLeft: "12px",
                paddingRight: "12px"
            }
        }
    },

    buttonItem: {
        "@media (min-width: 550px)": {
            maxWidth: "170px",
            display: "flex",
            justifyContent: "center",
        }
    },
    listItemButton: (theme: Theme, alpha: any, hasSubFolders: boolean) => ({
        flexDirection: "column",
        height: 50,
        p: 1,
        "&.Mui-selected, &.Mui-selected:hover": {
            background: "linear-gradient(99deg, rgba(219,231,255,0.65) 0%, rgba(233,216,255,0.65) 100%)",
            ...(hasSubFolders && {
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
            }),
        },
    }),
    listSubFolderItemButton: (theme: Theme, alpha: any) => ({
        height: "2.375rem",
        p: 1,
        "&.Mui-selected, &.Mui-selected:hover": {
            background: "linear-gradient(99deg, #DBE7FF 3.31%, #E9D8FF 96.69%)",
        },
    }),
    listStyles: {
        backgroundColor: "white",
        border: "solid 1px",
        borderColor: "rgba(135, 135, 135, 0.34)",
        borderRadius: "8px",
        padding: 0,
        animation: "height 0.5s ease-in-out",
        overflowX: "hidden",
        mt: 0,
    } as CSSProperties,
    iconButton: (color: PaletteColor, selected: boolean, theme: Theme, alpha: any): SxProps<Theme> => (
        selected
            ? {
                "&:hover": {
                    borderRadius: "50%",
                    backgroundColor: `${alpha(theme.palette?.[`${color}`].main, 0.3)}!important`,
                },
            }
            : {}),
    syncIcon: (color: any) => ({
        "&.MuiSvgIcon-root": {
            fontSize: "20px",
            fill: `${color}`,
            rotate: "90deg",
        },
    }),
    dossierNameAndCreationDateContainer: { marginLeft: 0, paddingLeft: 0, overflow: "hidden", textOverflow: "ellipsis" },
    dossierName: { marginLeft: 0, paddingLeft: 0, fontStyle: "normal", fontFamily: "Inter", fontWeight: 600, color: '#09226B' },
    creationDate: { opacity: 0.5 },
    controlCenterIcon: (theme: Theme) => ({
        color: theme.palette.text.secondary,
        alignSelf: "center",
        borderRadius: 1,

        marginRight: "5px",
        padding: "3px",
        "&:hover": {
            color: theme.palette.primary.main,
        },
    }),
    blockedMessageContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(4px)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 2,
    },
    blockedReasonText: {
        border: "2px solid #1976d2",
        borderRadius: 3,
        p: 3,
        bgcolor: "#bbdefb",
        maxWidth: "80%",
        boxShadow: 2,
    },
    bottomNavButtons: (width: number, selected: boolean) => ({ 
        fontFamily: "Inter",    
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "1.625rem",
        borderRadius: "14px",
        padding: "10px 10px",
        color: '#FFFFFF',
        ...(!selected ? {
            // background: "linear-gradient(64deg, #1A2B4C 6.57%, #264C9D 98.29%)",
            background: "#3660F4"
        } : {
            background: "linear-gradient(64deg, #959EB4 6.57%, #9DAED3 98.29%)",
        })
    }),
}